export const stringToIntegerSafe = (numberAsString: string): number => {
  try {
    const intI = parseInt(numberAsString, 10)
    if (isNaN(intI)) {
      return 0
    }
    return intI
  } catch (err) {
    return 0
  }
}

export const round = (number: number, decimalPlaces: number): number => {
  const expo: any = 'e' + decimalPlaces
  return Number(Math.round(number + expo) + 'e-' + decimalPlaces)
}
